import KNB from '@wmfe/mach-pro-knb';

import { AddressStruct, MapPoint, Pois } from '../types';

const isNull = (val): val is null => val == null;

const getSafeArea = () => Mach.env.safeAreaInsets;

const debounce = (fn, timeout = 200) => {
  let timer;
  return function (this, ...args: any[]) {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, timeout);
  };
};
const throttle = (fn, timeout = 200) => {
  let timer;
  let lastTime;
  let thisArg;
  const execute = (args) => {
    fn.apply(thisArg, args);
    lastTime = Date.now();
  };

  return function (this, ...args: any[]) {
    thisArg = this;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    if (!lastTime) {
      return execute(args);
    }
    const diff = Date.now() - lastTime;
    if (diff > timeout) {
      return execute(args);
    }
    timer = setTimeout(() => {
      execute(args);
    }, timeout);
  };
};
const toast = (info, duration = 3, extraInfo?: any) => {
  const Toast = Mach.requireModule('Toast');
  Toast.show(info, duration, extraInfo);
};

const getMapPoi = (pois: Pois): MapPoint & { addressStruct: AddressStruct; } => {
  // @ts-ignore
  const {
    location, province = '', subDistrict = '', street = '', streetNumber = '', premise = '', subPremise = '',
    neighborhood = '', postalCode = '', city = '', district = '', ...rest
  } = pois;
  const [longitude, latitude] = location.split(',');
  let addressStruct;
  if (province || subDistrict || street || streetNumber || premise) {
    addressStruct = {
      province,
      subDistrict,
      street,
      streetNumber,
      premise,
      subPremise,
      neighborhood,
      postalCode,
      city,
      district,
      ...rest
    };
  }
  /*
  TODO：- rest中的信息，在外层结构、和子结构addressStruct中都有，冗余，历史不明原因放在外层中，是否可以移除待确认
  */
  return {
    longitude: Number(longitude),
    latitude: Number(latitude),
    addressStruct,
    ...rest,
  };
};
const getMapPoiStr = (pois: Pois) => {
  const { location, ...rest } = pois;
  const [longitude, latitude] = location.split(',');
  return {
    longitude,
    latitude,
    location,
    ...rest,
  };
};

const getLocale = () => {
  const SLMPI18N = Mach.requireModule('Intl');
  const { locale = 'en' } = SLMPI18N.getCurrentLocaleInfo() || {};
  return locale;
};

enum CodeMap {
  /**
   * 香港区号
   */
  HongKong = '852',
  /**
   * 澳门区号
   */
  Macau = '853',
  /**
   * 台湾区号
   */
  TaiWan = '886',
  /**
   * 中国大陆区号
   */
  ChineseMainland = '86',
}
/**
 * @description 校验手机号是否正确
 * @param {number} code 区号
 * @param {string} phoneNumber 手机号
 * @return {boolean} 是否正确
 */
const validatorMobile = (code: string, phoneNumber: string): boolean => {
  if (!code || !phoneNumber) {
    return false;
  }
  return true;
};

function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}
function getStrJsonVal(jsonStr: any) {
  const defaultVal = null;
  if (!jsonStr || typeof jsonStr !== 'string') {
    return defaultVal;
  }
  try {
    const jsonObj = JSON.parse(jsonStr);
    if (isObject(jsonObj)) {
      return jsonObj;
    }
    return defaultVal;
  } catch (error) {
    return defaultVal;
  }
}

function openAppSetting() {
  KNB.use('openAppSetting', {
    fail() {
      // Native may reject when the current platform has no settings page.
    },
  });
}

function andriodAdapt() {
  const { osVersion, isAndroid } = Mach.env;
  let shouldAdapt = false;
  if (isAndroid) {
    const [, version] = (osVersion || '').split('_');
    // 系统 6 以下都进行keyboard-avoid适配处理
    if (version && compareVersion(version, '6') === -1) {
      shouldAdapt = true;
    }
  }
  return shouldAdapt;
}
/**
 * 比较版本
 * v1 > v2，返回1
 * v1 < v2，返回-1
 * v1 = v2，返回0
 * @param v1
 * @param v2
 * @returns
 */
function compareVersion(v1, v2) {
  v1 = `${v1}`.split('.');
  v2 = `${v2}`.split('.');
  const len = Math.max(v1.length, v2.length);

  while (v1.length < len) {
    v1.push('0');
  }
  while (v2.length < len) {
    v2.push('0');
  }

  for (let i = 0; i < len; i++) {
    const num1 = parseInt(v1[i]);
    const num2 = parseInt(v2[i]);

    if (num1 > num2) {
      return 1;
    } else if (num1 < num2) {
      return -1;
    }
  }

  return 0;
}

const getHornConfig = () => {
  const Horn = Mach.requireModule('SLCHorn');
  const config = Horn?.getAppConfig?.();
  return config || {};
};

const getAdderssStructObj = (obj): AddressStruct | null => {
  if (!obj) return null;
  const {
    province = '', subDistrict = '', street = '', streetNumber = '', premise = '', subPremise = '',
    neighborhood = '', postalCode = '', city = '', district = '', ...rest
  } = obj;
  return {
    province,
    subDistrict,
    street,
    streetNumber,
    premise,
    subPremise,
    neighborhood,
    postalCode,
    city,
    district,
    ...rest
  };
};

function getLngLatFromLocation(str: string) {
  const [longitude, latitude] = (str || '').split(',');
  return {
    longitude: Number(longitude),
    latitude: Number(latitude),
  };
}

export {
  getSafeArea,
  debounce,
  throttle,
  toast,
  getMapPoi,
  isNull,
  getLocale,
  getMapPoiStr,
  validatorMobile,
  getStrJsonVal,
  openAppSetting,
  andriodAdapt,
  getAdderssStructObj,
  getHornConfig,
  getLngLatFromLocation,
};
